import webStorage from 'utils/webstorage';
import tdaConfig from 'lib/util/tda.config';
import langFromUrl from 'lib/util/langFromUrl';
import PageCache from 'lib/page-cache';
import 'lib/loader/series';
import 'lib/transforms/series.mapByCode';

var __lang = langFromUrl();
var __recentKey = tdaConfig.tda.code + 'recent_' + __lang;

function __recentItemCount() {
  var currStore = webStorage.getSessionStorage().getItem(__recentKey);
  if (!currStore) {
    return 0;
  }
  return JSON.parse(currStore).length;
}

// check only on year and series? this means we'll be removing trims!
function __recentItemIndex(recentArr, recentItemObj) {
  return recentArr.findIndex(function (item) {
    return item.year === recentItemObj.year && item.series === recentItemObj.series;
  });
}

function __recentItemExists(recentItemObj) {
  var currStore = webStorage.getSessionStorage().getItem(__recentKey);
  if (!currStore) {
    return false;
  }
  var recentArr = JSON.parse(currStore);
  var foundIndex = __recentItemIndex(recentArr, recentItemObj)
  if (foundIndex >= 0) {
    return true;
  }
  return false;
}

// used by OLD (still in use) SLP forms to prepopulate selected vehicle card
// both long and short forms, and SLP confirmation pages
function __oldSlpRecentSave(obj) {
  var seriesName;
  PageCache.await('series.map')
    .then(function (seriesMap) {
      if (obj.series && obj.series !== '') {
        seriesName = seriesMap[obj.series].series_name;
      }
      webStorage.getSessionStorage().setItem('year', obj.year || '');
      webStorage.getSessionStorage().setItem('series', obj.series || '');
      webStorage.getSessionStorage().setItem('seriesName', seriesName || '');
      webStorage.getSessionStorage().setItem('model', obj.trim || '');
      webStorage.getSessionStorage().setItem('trim', obj.trimCode || '');
      webStorage.getSessionStorage().setItem('brand', 'toyota');
    });
}

/* Todo: add displayName here as well? To skip mapByCode!? */
function __validateSave(obj) {
  var series = obj.series.split(' ')[0]; // totally safe?
  var year = obj.year || '';
  var saveObj = {
    year: year.toString(),
    series: series || '',
  };
  if (obj.trimCode) {
    saveObj.trimCode = obj.trimCode.toString();
  }
  // console.log('modded obj: ', $.extend(obj, saveObj));
  return $.extend(obj, saveObj);
}

export default {
  // year, series, trim, trimcode.
  // year & series are required, trim & trimCode are optional (we dont always have these)
  saveVehicle: function (saveObj) {
    var obj = saveObj;
    if (!saveObj.year || !saveObj.series) {
      return;
    }
    // __oldSlpRecentSave(obj); // saves things to session
    var recentItemObj = __validateSave(obj);
    var currStore = webStorage.getSessionStorage().getItem(__recentKey);
    var recentArr = [];

    // if we have items already
    if (__recentItemCount()) {
      recentArr = JSON.parse(currStore);

      // if this recent item already exists, drop it and stick it at the front
      if (__recentItemExists(recentItemObj)) {
        var foundIndex = __recentItemIndex(recentArr, recentItemObj);
        recentArr.splice(foundIndex, 1);
        recentArr.unshift(recentItemObj);
        webStorage.getSessionStorage().setItem(__recentKey, JSON.stringify(recentArr));
      } else {
        recentArr.unshift(recentItemObj);
        webStorage.getSessionStorage().setItem(__recentKey, JSON.stringify(recentArr));
      }
    } else {
      recentArr.push(recentItemObj);
      webStorage.getSessionStorage().setItem(__recentKey, JSON.stringify(recentArr));
    }
  },

  // return an arr of recently viewed
  getVehicles: function () {
    if (__recentItemCount()) {
      return JSON.parse(webStorage.getSessionStorage().getItem(__recentKey));
    }
    return [];
  },

  getMostRecentVehicleId: function () {
    var vehicles = this.getVehicles();
    if (vehicles.length) {
      var series = vehicles[0].series;
      if (series === 'chr') series = 'c-hr';
      return vehicles[0].year + '|' + series;
    }
    return ''; // todo: return null and test
  },

  getMostRecentVehicle: function () {
    var vehicles = this.getVehicles();
    if (vehicles.length) {
      return vehicles[0];
    }
    return null;
  }
};
